<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            Work Periods
            <div class="settings-header__btn">
              <el-button type="success" size="mini" @click="routerLink('settings-dashboard')">Settings Dashboard</el-button>
            </div>
          </div>

          <div>
            <el-button type="primary" plain size="mini" @click="openModal">
              {{$t('settings_humanCapitalManagement_addPeriods')}}
            </el-button>
            <el-table
                max-height="650"
                :data="tableData"
                style="width: 100%; margin-top: 10px;">
              <el-table-column
                  label="ID"
                  type="index"
                  width="50">
              </el-table-column>
              <el-table-column
                  prop="code"
                  label="Code"
                  width="100">
              </el-table-column>
              <el-table-column
                  prop="name"
                  label="Name">
              </el-table-column>
              <el-table-column
                  prop="created"
                  label="Created By"
                  width="140">
              </el-table-column>
              <el-table-column
                  label="Action"
                  width="120">
                <template slot-scope="scope">
                  <el-button
                      size="mini"
                      type="primary"
                      plain
                      icon="el-icon-edit"
                      @click="handleEdit(scope.$index, scope.row)"></el-button>
                  <el-button
                      size="mini"
                      type="danger"
                      icon="el-icon-delete"
                      plain
                      @click="handleDelete(scope.$index, scope.row)"></el-button>
                </template>
              </el-table-column>
            </el-table>
            <human-capital-add-period-modal
                @loadList="loadList"
                ref="humanCapitalAddPeriodModal"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import HumanCapitalAddPeriodModal from "@/components/settings/humanCapitalManagement/AddPeriodModal";
export default {
  name: "WorkPeriods",
  components: {
    HumanCapitalAddPeriodModal
  },
  data(){
    return {
      tableData: []
    }
  },
  mounted() {
    this.loadList()
  },
  methods:{
    loadList(){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.get(`/api/v1/workingHoursPeriod/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            console.log('response', response.data);
            this.tableData = response.data.fieldsList;
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
    },
    openModal(){
      this.$refs.humanCapitalAddPeriodModal.open();
    },
    handleEdit(index, row) {
      this.$refs.humanCapitalAddPeriodModal.openEdit(row.itemId);
    },
    handleDelete(index, row) {
      this.$confirm(this.$t('settings_humanCapitalManagement_ThisWillPermanentlyDeleteThePeriod'), this.$t('general_warning'), {
        confirmButtonText: this.$t('general_ok'),
        cancelButtonText: this.$t('general_cancel'),
        type: 'info'
      }).then(() => {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.get(`/api/v1/workingHoursPeriod/delete?companyId=${this.$route.query.companyId}&periodId=${row.itemId}`)
            .then(response => {
              this.notification(this.$t('general_success'), this.$t('notification_periodRemoved'), "success");
              this.loadList();
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('settings_general_deleteCompleted')
        });
      });
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    routerLink(page) {
      this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
    }
  }
}
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
